import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=48c38847&scoped=true&"
import script from "./FolderItem.vue?vue&type=script&lang=js&"
export * from "./FolderItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=48c38847&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c38847",
  null
  
)

export default component.exports